import Http from './../http';

const prefix = '/link';

export const getWebsiteLink = website_id => {
    return Http.authApi().get(`${prefix}/get/${website_id}`);
  };




// WEBPACK FOOTER //
// ./src/js/services/editor/link.js